export const SearchTypeContents = 2 as const;
export type TSearchTypeContents = typeof SearchTypeContents;

/** elementSubType1 */
export enum ContentsType {
	MATCH_ALL_FRAGMENTS = 4,
	MATCH_ALL_WHOLE_WORDS_AND = 0,
	MATCH_ANY_FRAGMENT = 5,
	MATCH_ANY_WHOLE_WORDS_OR = 2,
	MATCH_EXACTLY = 1,
	MATCH_EXCLUDE = 3,
}
